import StrainTypeTiles from "./StrainTypeTiles";

export default StrainTypeTiles;
